export const breadcrumbs = {
  '@media screen and (max-width: 992px)': {
    padding: 0,
    display: 'none'
  },
  'li > a, li::before, li > a:visited': {
    color: 'grey-70'
  },
  'li:last-child': {
    color: 'grey-90',
    fontWeight: 500
  }
}

export const formContainerStyle = {
  '& .form-col': {
    width: [null, 'calc(56% - 1em)', 'calc(52% - 1em)', 'calc(43% - 1em)']
  }
}

export const hero = {
  flexDirection: 'column',
  overflow: 'visible',
  position: 'relative',
  display: ['flex', 'block']
}

export const heroTitleWithLogo = {
  display: 'grid',
  gridTemplateColumns: ['1fr', '158px 1fr'],
  alignItems: 'center',
  '& div, span': {
    display: 'contents'
  },
  '& > span': {
    display: ['none', 'inline-block']
  },
  '& h1 ~ p': {
    gridColumn: 'span 2'
  }
}

export const heroLogo = {
  py: 'xxs',
  px: 'sm',
  lineHeight: 0,
  backgroundColor: 'white',
  marginRight: 'sm',
  borderRadius: '0.5em',
  width: 'fit-content'
}

export const heroImgStyle = {
  position: 'absolute',
  bottom: 0,
  maxWidth: [440, 440, 500],
  right: ['-20%', '-15%', 0]
}

export const hideOnMobile = {
  '@media screen and (max-width: 767px)': {
    display: 'none'
  }
}

export const hideOnTablet = {
  '@media screen and (max-width: 1199px)': {
    display: 'none'
  }
}

export const row = {
  mx: [0, -15],
  display: 'flex',
  flexDirection: ['column', 'row']
}

export const column = {
  mx: [0, 15],
  position: 'relative',
  mb: [0],
  '@media screen and (max-width: 767px)': {
    width: '100%'
  },
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: 'auto'
}

export const copyContainer = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flex: 1,
  maxWidth: [500, 450, 500],
  margin: '0 auto 0 0',
  paddingTop: 0,
  paddingBottom: 0,
  '> span > div': {
    minWidth: 122
  }
}

export const container = {
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: 1200,
  boxSizing: 'border-box',
  paddingLeft: 15,
  paddingRight: 15,
  display: 'flex',
  flexDirection: 'column'
}

export const postcodeHeroDescription = {
  color: 'grey-90',
  lineHeight: 1.44,
  fontSize: 16,
  '& > p': {
    marginTop: 'md',
    marginBottom: 'md',
    mx: 0
  }
}

export const postcodeHero = {
  p: { ...postcodeHeroDescription, mb: 0 }
}

export const spinnerStyle = {
  spinner: { width: 45, height: 45, backgroundSize: 45, mt: -4 },
  text: { display: 'none' }
}

export const spinnerStyleLarge = {
  ...spinnerStyle,
  spinner: { ...spinnerStyle.spinner, mt: 40 }
}

export const p0PictureStyle = {
  position: 'absolute',
  height: '100%',
  right: 0,
  display: 'flex',
  justifyContent: 'flex-end'
}

export const blackFridayImage = {
  ...p0PictureStyle,
  ...hideOnTablet,
  padding: '32px 0',
  height: 'auto',
  maxWidth: '50%'
}

export const hasP0 = {
  maxWidth: 292
}

export const heroWrapper = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column'
}

export const containerStyle = {
  mx: 'auto',
  boxSizing: 'border-box',
  px: 16,
  maxWidth: ['100%', 800, 1000],
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  '@media screen and (min-width: 1200px)': {
    maxWidth: 1200
  },
  justifyContent: 'center'
}

export const providerContainerStyle = {
  py: ['md', 'xl'],
  '& .black-friday-image': {
    display: 'none'
  }
}

export const packagesHeroContentStyles = {
  py: 'sm'
}
